export default __webpack_public_path__ + "assets/emptyClassroomMenu-918901c.svg";